/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Pause = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Pause"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#0E0E0E"
      d="M9.25 6.4c0-.773-.616-1.4-1.375-1.4-.76 0-1.375.627-1.375 1.4v11.2c0 .773.616 1.4 1.375 1.4.76 0 1.375-.627 1.375-1.4zm8.25 0c0-.773-.616-1.4-1.375-1.4-.76 0-1.375.627-1.375 1.4v11.2c0 .773.616 1.4 1.375 1.4.76 0 1.375-.627 1.375-1.4z"
      className="SVG"
    />
  </svg>
);

export const PauseIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'pause-icon'}
      icon={Pause}
      {...props}
      size={size}
    />
  );
};
